
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.04 35.28c-.13-.24-.51-.4-1.07-.71-.56-.31-3.31-1.79-3.83-2-.52-.21-.89-.32-1.29.24s-1.54 1.8-1.89 2.17c-.35.37-.68.4-1.24.1-.56-.31-2.37-.98-4.48-3-1.64-1.58-2.71-3.49-3.03-4.07-.31-.58 0-.88.29-1.15.27-.25.6-.65.89-.97.3-.32.4-.56.61-.93.2-.37.12-.71-.01-1-.13-.29-1.17-3.14-1.6-4.3-.43-1.16-.91-.99-1.25-1-.33-.01-.71-.07-1.09-.09-.38-.01-1 .11-1.55.66-.54.55-2.07 1.88-2.17 4.68-.1 2.81 1.84 5.59 2.11 5.99.27.39 3.71 6.48 9.42 8.98s5.74 1.74 6.79 1.68c1.05-.06 3.43-1.25 3.95-2.57.53-1.31.57-2.46.43-2.7l.01-.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.33 40.7A20.366 20.366 0 019 29.5C9 18.18 18.18 9 29.5 9S50 18.18 50 29.5 40.82 50 29.5 50c-3.78 0-7.32-1.02-10.36-2.81L9 50l3.33-9.3v0z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    